<template>
  <div class="inbox-section">
    <v-container class="d-flex justify-center align-center">
      <div :class="!hasPay && paymentWave ? 'snap-wrapper' : 'card-wrapper'">
        <div v-if="!hasRegister && !berkasType">
          <v-card class="inbox-card pa-5">
            <v-container grid-list-xs py-5>
              <center>
                <p>
                  Anda belum mendaftar sebagai siswa, silakan daftar di menu
                  Beranda.
                </p>
              </center>
            </v-container>
          </v-card>
        </div>

        <div class="reupload" v-if="berkasType === 'reupload'">
          <v-card class="inbox-card pa-5">
            <v-container
              grid-list-xs
              class="mb-5"
              v-if="hasReupload && currentWave"
            >
              <v-row class="d-flex justify-center px-5">
                <v-col
                  cols="12"
                  sm="5"
                  v-for="(file, index) in files"
                  :key="file.type"
                  class="ma-5"
                >
                  <center>
                    <h3>{{ file.text }}</h3>

                    <div
                      class="preview d-flex flex-column justify-center align-center mt-5"
                      :data-identification="file.type"
                    >
                      <p class="text-preview">Preview</p>

                      <img
                        v-if="checkImage(file.type)"
                        class="preview-image"
                        :src="showImage(file.type)"
                        alt="image"
                      />
                    </div>

                    <p
                      class="red--text"
                      style="text-align: center"
                      v-if="checkImageError(file.type)"
                    >
                      {{ getImageError(file.type) }}
                    </p>

                    <v-btn
                      color="accentDarkBlue"
                      class="white--text mt-4"
                      @click="uploadImage(index, file.type)"
                      >Upload</v-btn
                    >

                    <!-- <input
                      type="file"
                      style="display: none;"
                      ref="attachment"
                      accept="image/*"
                      :data-identification="file.type"
                      @change="onChangeUploadImage"
                    />-->

                    <image-uploader
                      :quality="1"
                      :preview="false"
                      outputFormat="file"
                      ref="attachment"
                      doNotResize="['gif', 'svg', 'jpeg', 'jpg', 'png']"
                      accept="image/*"
                      style="display: none"
                      @input="onChangeUploadImage"
                    ></image-uploader>
                  </center>
                </v-col>
              </v-row>

              <center class="mt-5">
                <b
                  >*Ukuran minimal file adalah 1MB, maksimal 10MB (format: jpeg,
                  jpg, png).</b
                >
              </center>
              <center>
                <v-btn
                  color="accentDarkBlue"
                  class="white--text my-5"
                  @click="submitForm"
                  >Reupload Berkas</v-btn
                >
              </center>
            </v-container>

            <v-container grid-list-xs v-if="!hasReupload" py-5>
              <center>
                <p>
                  Anda tidak memiliki berkas yang harus dikirim ulang, silakan
                  tunggu konfirmasi dari admin!
                </p>
              </center>
            </v-container>

            <v-container grid-list-xs v-if="hasReupload && !currentWave" py-5>
              <center>
                <p>
                  Pendaftaran telah ditutup, Anda tidak dapat melengkapi berkas
                </p>
              </center>
            </v-container>
          </v-card>
        </div>

        <div class="payment" v-if="berkasType === 'payment'">
          <v-container grid-list-xs v-if="!hasPay && paymentWave">
            <center>
              <div id="snap-container"></div>
            </center>
          </v-container>
          <v-card v-else class="inbox-card pa-5">
            <v-container grid-list-xs v-if="hasPay" py-5>
              <center>
                <p>Anda sudah melakukan pembayaran.</p>
              </center>
            </v-container>

            <v-container grid-list-xs v-if="!hasPay && !paymentWave" py-5>
              <center>
                <p>
                  Pendaftaran telah ditutup, Anda tidak dapat melengkapi
                  pembayaran
                </p>
              </center>
            </v-container>
          </v-card>
        </div>
      </div>
      <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import ImageUploader from "vue-image-upload-resize";
import { EventBus } from "../event-bus";
import { locale } from "moment";
import moment from "moment";

export default {
  components: {
    ImageUploader,
  },
  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    color: "red",
    files: [],
    urls: {
      url_lmp_foto: "",
      url_lmp_kesehatan: "",
      url_lmp_akte: "",
      url_lmp_kk: "",
      url_lmp_raport: "",
      url_lmp_prestasi: "",
      url_lmp_gambar_anm: "",
      url_lmp_kesanggupan_tata_tertib: "",
    },
    fileImages: {
      lmp_foto: "",
      lmp_kesehatan: "",
      lmp_akte: "",
      lmp_kk: "",
      lmp_raport: "",
      lmp_prestasi: "",
      lmp_gambar_anm: "",
      lmp_kesanggupan_tata_tertib: "",
    },
    id: "",
    hasRegister: "",
    berkasType: "",
    hasReupload: "",
    hasPay: "",
    bankAccountInfo: {
      number: "7146540583 (Bank Syariah Indonesia)",
      name: "PPDB SMK RUS",
      nominal: "Rp 120.000",
    },
    struk: "",
    urlStruk: "",
    imageErrors: [],
    selectedImageType: "",
    currentWave: "",
    paymentWave: "",
    date: "",
    snapToken: "",
  }),
  async mounted() {
    const queryParams = this.$route.query;
    // console.log(queryParams["transaction_status"]);
    setTimeout(() => {
      switch (queryParams["transaction_status"]) {
        // case "pending":
        //   EventBus.$emit(
        //     "showSnackbar",
        //     "Pembayaran sedang diproses",
        //     "primary"
        //   );
        //   break;
        case "capture":
        case "settlement":
          EventBus.$emit("showSnackbar", "Pembarayan berhasil", "green");
          break;
        case "deny":
          EventBus.$emit("showSnackbar", "Pembayaran gagal", "red");
          break;
      }
    }, 100);
    this.initData();
  },
  methods: {
    async initData() {
      EventBus.$emit("startLoading");
      this.id = localStorage.getItem("id");
      try {
        await this.getNominal();
        await this.getBerkas();
        this.checkWave();

        if (this.berkasType === "payment" && !this.hasPay && this.paymentWave) {
          this.initSnap();
        }
      } catch (e) {
      }
      EventBus.$emit("stopLoading");
    },
    async initSnap() {
      EventBus.$emit("startLoading");
      window.snap.hide();
      await this.getSnapToken();
      window.snap.embed(this.snapToken, {
        embedId: "snap-container",
        onSuccess: (result) => {
          EventBus.$emit("showSnackbar", {
            text: "Pembayaran berhasil",
            color: "green",
          });
          this.initData();
        },
        onPending: (result) => {
          // EventBus.$emit(
          //   "showSnackbar",
          //   "Pembayaran sedang diproses",
          //   "primary"
          // );
          this.initData();
        },
        onError: (result) => {
          EventBus.$emit("showSnackbar", "Pembayaran gagal", "red");
          this.initData();
        },
        onClose: function () {
          EventBus.$emit(
            "showSnackbar",
            "Pembayaran belum diselesaikan",
            "red"
          );
          this.initData();
        },
      });
    },
    checkWave() {
      moment.locale("id");

      const currentTime = moment(localStorage.getItem("date"));
      this.date = currentTime;

      const currentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.close)
        );
        return range.contains(currentTime);
      });

      // Can upload payment after 2 days
      const paymentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.close).add(2, "days")
          // moment(itemDate.close)
        );
        return range.contains(currentTime);
      });

      if (currentWave.length > 0) this.currentWave = currentWave;
      else this.currentWave = "";

      if (paymentWave.length > 0) this.paymentWave = paymentWave;
      else this.paymentWave = "";
    },
    async getSnapToken() {
      try {
        const tokenRes = await axios.get(`${this.$api}/snap-token`);
        this.snapToken = tokenRes.data.PAYLOAD;
        // console.log(tokenRes);
      } catch (e) {
        // console.log(e);
      }
    },
    async getNominal() {
      const profileRes = await axios.get(`${this.$api}/profile?id=${this.id}`);
      const res = profileRes.data;
      // console.log(res);
      if (res.PAYLOAD.sw_id) {
        var u_id = res.PAYLOAD.sw_id.toString();
        var lastThree = parseInt(u_id.substr(u_id.length - 3)) + 120000;
        var nominal = lastThree.toString().match(/.{3}/g).join(".");
        this.bankAccountInfo.nominal = "Rp" + nominal;
      } else {
        throw "Kamu belum mendaftar sebagai calon siswa";
      }
    },
    async getBerkas() {
      EventBus.$emit("startLoading");

      const res = await axios.get(`${this.$api}/cek-berkas?id=${this.id}`);
      const files = res.data.PAYLOAD;

      if (
        res.data.STATUS === "ERROR" &&
        res.data.MESSAGE === "Siswa tidak valid / belum terdaftar."
      ) {
        this.hasRegister = false;
      } else if (
        res.data.STATUS === "SUCCESS" &&
        files &&
        !files.lmp_bukti_pembayaran
      ) {
        this.berkasType = "reupload";
        this.hasReupload = true;

        for (let file in files) {
          if (files[file] === "N") {
            let fileName;

            if (file === "lmp_akte") fileName = "Akta Kelahiran";
            else if (file === "lmp_foto") fileName = "Pas Foto Diri 3x4";
            else if (file === "lmp_gambar_anm") fileName = "Hasil Karya Gambar";
            else if (file === "lmp_kesehatan")
              fileName = "Catatan Kesehatan (dari dokter/puskesmas)";
            else if (file === "lmp_kk") fileName = "Kartu Keluarga";
            else if (file === "lmp_prestasi") fileName = "Prestasi";
            else if (file === "lmp_raport") fileName = "Raport";
            else if (file === "lmp_kesanggupan_tata_tertib")
              fileName = "Form Kesanggupan Menaati Tata Tertib";

            this.files.push({ text: fileName, type: file });
          }
        }
      } else if (
        res.data.STATUS === "ERROR" &&
        res.data.MESSAGE ===
          "Tidak ada berkas untuk dikirim, mohon tunggu konfirmasi dari admin."
      ) {
        this.berkasType = "reupload";
        this.hasReupload = false;
      } else if (
        res.data.STATUS === "SUCCESS" &&
        files &&
        files.lmp_bukti_pembayaran === "N"
      ) {
        this.berkasType = "payment";
        this.hasPay = false;
      } else if (
        res.data.STATUS === "ERROR" &&
        res.data.MESSAGE === "Berkas sudah lengkap."
      ) {
        this.berkasType = "payment";
        this.hasPay = true;
      }

      EventBus.$emit("stopLoading");
    },

    uploadImage(index, type) {
      this.selectedImageType = type;
      this.$refs.attachment[index].$el.children[1].click();
    },

    checkImage(model) {
      for (var url in this.urls) {
        if (url === `url_${model}` && this.urls[url] !== "") return true;
      }
    },

    showImage(model) {
      for (var url in this.urls) {
        if (url === `url_${model}`) return this.urls[url];
      }
    },

    onChangeUploadImage(e) {
      const file = e;
      const type = this.selectedImageType;

      if (file.size < 1024 * 1024) {
        this.text = "Ukuran minimal file adalah 1MB!";
        this.snackbar = true;
        return;
      }

      if (file.size > 1e7) {
        this.text = "File tidak boleh lebih dari 10MB!";
        this.snackbar = true;
        return;
      }

      if (type === "lmp_foto") {
        this.urls.url_lmp_foto = URL.createObjectURL(file);
        this.fileImages.lmp_foto = file;
      } else if (type === "lmp_kesehatan") {
        this.urls.url_lmp_kesehatan = URL.createObjectURL(file);
        this.fileImages.lmp_kesehatan = file;
      } else if (type === "lmp_akte") {
        this.urls.url_lmp_akte = URL.createObjectURL(file);
        this.fileImages.lmp_akte = file;
      } else if (type === "lmp_kk") {
        this.urls.url_lmp_kk = URL.createObjectURL(file);
        this.fileImages.lmp_kk = file;
      } else if (type === "lmp_raport") {
        this.urls.url_lmp_raport = URL.createObjectURL(file);
        this.fileImages.lmp_raport = file;
      } else if (type === "lmp_prestasi") {
        this.urls.url_lmp_prestasi = URL.createObjectURL(file);
        this.fileImages.lmp_prestasi = file;
      } else if (type === "lmp_gambar_anm") {
        this.urls.url_lmp_gambar_anm = URL.createObjectURL(file);
        this.fileImages.lmp_gambar_anm = file;
      } else if (type === "lmp_kesanggupan_tata_tertib") {
        this.urls.url_lmp_kesanggupan_tata_tertib = URL.createObjectURL(file);
        this.fileImages.lmp_kesanggupan_tata_tertib = file;
      }

      document.querySelector(
        `.preview[data-identification='${type}'] .text-preview`
      ).style.display = "none";
      document.querySelector(
        `.preview[data-identification='${type}']`
      ).style.minHeight = 0;
    },

    dataURItoBlob(dataURI, contentType) {
      var byteString = atob(dataURI.split(",")[1]);

      // var mimeString = dataURI
      //   .split(',')[0]
      //   .split(':')[1]
      //   .split(';')[0];

      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      var bb = new Blob([ab], { type: contentType });
      return bb;
    },

    validateImage() {
      this.imageErrors = [];

      for (let image in this.fileImages) {
        let fileNeeded = this.files.filter((file) => file.type === image);

        if (this.fileImages[image]) {
          let fileName = this.fileImages[image].name;
          let extension = fileName.split(".").pop();

          const standartExtensions = ["png", "jpg", "jpeg"];
          const isRight = standartExtensions.filter(
            (ex) => ex === extension.toLowerCase()
          );

          if (isRight.length <= 0) {
            this.imageErrors.push({
              model: image,
              error: "Format file harus berupa .png / .jpg / .jpeg",
            });
          }
        } else if (!this.fileImages[image] && fileNeeded.length > 0) {
          this.imageErrors.push({
            model: image,
            error: "File wajib diisi",
          });
        }
      }
    },

    checkImageError(model) {
      let isError = this.imageErrors.filter((err) => err.model === model);

      if (isError.length > 0) return true;
      else return false;
    },

    getImageError(model) {
      const error = this.imageErrors.filter((err) => err.model === model);
      if (error.length <= 0) return;
      return error[0].error;
    },

    async submitForm() {
      this.validateImage();
      if (this.imageErrors.length > 0) return;

      EventBus.$emit("startLoading");
      let i = 1;
      let currentAvailableIndex = 0;
      let fileLength = 0;

      for (let check in this.fileImages) {
        if (this.fileImages[check]) fileLength++;
      }

      for (let fileImage in this.fileImages) {
        if (this.fileImages[fileImage] !== "") {
          currentAvailableIndex++;

          let fileType;
          if (fileImage === "lmp_foto") fileType = "FOTO_DIRI";
          else if (fileImage === "lmp_kesehatan") fileType = "CEK_KESEHATAN";
          else if (fileImage === "lmp_akte") fileType = "AKTE";
          else if (fileImage === "lmp_kk") fileType = "KK";
          else if (fileImage === "lmp_raport") fileType = "RAPORT";
          else if (fileImage === "lmp_prestasi") fileType = "PRESTASI";
          else if (fileImage === "lmp_gambar_anm") fileType = "GAMBAR_ANIMASI";
          else if (fileImage === "lmp_kesanggupan_tata_tertib")
            fileType = "KESANGGUPAN_TATA_TERTIB";

          const formData = new FormData();

          formData.set("id", this.id);
          formData.set("file", this.fileImages[fileImage]);
          formData.set("type", fileType);

          const config = {
            onUploadProgress: (progressEvent) => {
              let percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              EventBus.$emit("setPercentage", percentCompleted);
            },
          };

          if (fileLength > 1) {
            EventBus.$emit(
              "setPercentageDescription",
              `${currentAvailableIndex}/${fileLength}`
            );
          }
          await axios.post(`${this.$api}/berkas`, formData, config);
        }

        if (i === Object.keys(this.fileImages).length) {
          EventBus.$emit("stopLoading");
          EventBus.$emit("setPercentageDescription", "");
          await this.getBerkas();
        }

        i++;
      }
    },

    // Payment

    uploadPayment() {
      this.$refs.payment.$el.children[1].click();
    },

    onChangeUploadImagePayment(e) {
      const file = e;

      this.struk = file;
      this.urlStruk = URL.createObjectURL(file);

      document.querySelector(`.preview .text-preview`).style.display = "none";
      document.querySelector(`.preview`).style.minHeight = 0;
    },

    paymentValidation() {
      this.imageErrors = [];

      if (this.struk) {
        let fileName = this.struk.name;
        let extension = fileName.split(".").pop();

        const standartExtensions = ["png", "jpg", "jpeg"];
        const isRight = standartExtensions.filter(
          (ex) => ex === extension.toLowerCase()
        );

        if (isRight.length <= 0) {
          this.imageErrors.push({
            model: "struk",
            error: "Format file harus berupa .png / .jpg / .jpeg",
          });
        }
      } else {
        this.imageErrors.push({
          model: "struk",
          error: "File wajib diisi",
        });
      }
    },

    async submitPayment() {
      this.paymentValidation();
      if (this.imageErrors.length > 0) return;

      EventBus.$emit("startLoading");

      const formData = new FormData();
      formData.set("id", this.id);
      formData.set("file", this.struk);
      formData.set("type", "BUKTI_PEMBAYARAN");

      const res = await axios.post(`${this.$api}/berkas`, formData);
      if (
        res.data.STATUS === "SUCCESS" &&
        res.data.MESSAGE === "Berhasil mengirim berkas!"
      )
        await this.getBerkas();
    },
  },
};
</script>

<style scoped>
#snap-container {
  width: 80%;
}
.inbox-section {
  min-height: 80vh;
}

.card-wrapper,
.snap-wrapper {
  margin: 100px 0;
  width: 70%;
}

.bank-info-card {
  width: 100%;
  border-left: 8px solid #374785;
}

.payment-card {
  width: 450px;
}

.preview {
  border: 1px solid #374785;
  min-height: 200px;
  max-height: 300px;
  overflow: hidden;
  width: 200px;
}

.form-payment {
  width: 300px;
}

.preview-image {
  width: 100%;
  height: auto;
}

.login-title {
  font-family: "Montserrat", sans-serif !important;
}

.w-100 {
  width: 100%;
}

@media screen and (max-width: 500px) {
  .card-wrapper {
    width: 80%;
  }

  .preview {
    width: 100%;
  }
}

@media screen and (max-width: 720px) {
  #snap-container {
    width: 100%;
  }

  .snap-wrapper {
    width: 100%;
  }
}
</style>